// The satchel on the page (shared/_satchel) and the forge's recipes, brought
// level with a bag the server just answered with — a shift's payout, a
// thing made at the forge — without a reload. Every plain list is redrawn
// from the bag (the Assayer's list, with a sell form on each line, is left
// to the next paint), the fold's count is updated, and each recipe row
// re-reads what is short so a Make button lights the moment the bag covers
// it and dims the moment it does not.

const MATERIAL_NAMES = {}

export function materialName(key) {
  return MATERIAL_NAMES[key] || key.replace(/_/g, " ")
}

// What a recipe is short of, against a bag: [[key, missing], ...].
export function shortFor(needs, satchel) {
  return Object.entries(needs || {})
    .map(([ key, count ]) => [ key, count - (satchel?.[key] || 0) ])
    .filter(([ , missing ]) => missing > 0)
}

export function shortLine(short) {
  return `Short ${short.map(([ key, missing ]) => `${missing} ${materialName(key).toLowerCase()}`).join(", ")}.`
}

export function repaintSatchel(satchel, root = document) {
  root.querySelectorAll("[data-satchel]").forEach((box) => {
    if (box.querySelector(".ll-satchel__sell")) return
    box.querySelectorAll("[data-satchel-key]").forEach((li) => { MATERIAL_NAMES[li.dataset.satchelKey] ||= li.querySelector(".ll-satchel__name")?.textContent })
    const entries = Object.entries(satchel).filter(([ , count ]) => count > 0)
    let list = box.querySelector(".ll-satchel__list")
    if (entries.length === 0) {
      list?.remove()
      return
    }
    if (!list) {
      box.querySelector("[data-satchel-empty]")?.remove()
      list = document.createElement("ul")
      list.className = "ll-satchel__list"
      list.setAttribute("aria-label", "The satchel")
      box.append(list)
    }
    // A line whose count fell to nothing goes; the forge spends as well as
    // the shift pays.
    list.querySelectorAll("[data-satchel-key]").forEach((li) => {
      if (!(satchel[li.dataset.satchelKey] > 0)) li.remove()
    })
    entries.forEach(([ key, count ]) => {
      let li = list.querySelector(`[data-satchel-key="${key}"]`)
      if (!li) {
        li = document.createElement("li")
        li.className = "ll-satchel__item"
        li.dataset.satchelKey = key
        li.innerHTML = `<span class="ll-satchel__name"></span><span class="ll-satchel__count">×<span data-satchel-count></span></span>`
        li.querySelector(".ll-satchel__name").textContent = materialName(key)
        list.append(li)
      }
      li.querySelector("[data-satchel-count]").textContent = count
    })
  })
  const total = Object.values(satchel).reduce((sum, count) => sum + count, 0)
  root.querySelectorAll("[data-satchel-total]").forEach((node) => { node.textContent = total })

  repaintRecipes(satchel, root)
}

// Each recipe row: lit when the bag covers it, dim and saying what is short
// when it does not. A row blocked for any other reason — owned, misfit, the
// door shut — says so already and is left alone.
export function repaintRecipes(satchel, root = document) {
  root.querySelectorAll("#smithy [data-recipe][data-needs]").forEach((row) => {
    if (row.dataset.recipeBlocked) return
    const short = shortFor(JSON.parse(row.dataset.needs), satchel)
    const button = row.querySelector("button")
    if (!button) return
    button.disabled = short.length > 0
    button.classList.toggle("ll-btn--primary", short.length === 0)
    row.classList.toggle("ll-work__job--shut", short.length > 0)
    const reason = row.querySelector("[data-recipe-reason]")
    if (reason) {
      reason.hidden = short.length === 0
      if (short.length) reason.textContent = shortLine(short)
    }
  })
}
